import moment from 'moment';
import {calculateFinalPriceConcierge} from '@/utils/index.js'
import {getPromotionName} from '@/utils/bePromotionRule.js'
import store from '../index.js'
import _ from 'lodash';
import Vue from 'vue';

export default{
	state: {
		be_filter: {
			date: {
				check_in: moment().toDate(),
				check_out: moment().add(1,'d').toDate(),
			},
			guest: {
				adult: 1,
				child: 0,
				infant: 0,
			},
			promo_code: '',
		},
		be_filter_detail:{
			type: 'room_type',
			data: {}
		},
		agent_id: '',
		be_first_load: true,
		be_price: [0,0],
    be_sort_by: 'room_type',
    trx_be:{
    	room_rate_details: [],
    	room_rate_guest: [],
    	room_rate_custom: [],
    	customer_details: {
    		first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        address: "",
        title: "",
        country: "",
				nationality: "",
				day_of_birth: ""
    	},
    	visitor_details: {
    		first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        address: "",
        title: "",
        country: "",
				nationality: "",
				day_of_birth: ""
    	},
    	ticket_owner: 'me',
    	additional_service: [],
    	special_request: [],
    	qty: {
    		room_rate: 0,
    		additional_service: 0
    	},
    	custom_time:{
    		check_in: '',
    		check_out: ''
    	},
    	note: ''
    },
    be_trx_payment:{},
    room_avbl:[],
    be_payment:{

    },
    concierge:{
    	booking_number: '',
    	pin: '',
    	token: '',
    	folio: '',
    	detail_id: '',
    	pin_applied: false
    },
    concierge_reservation:{
    	status: '',
    	guest_profile: {},
    	room: {},
			reservation_id: ''
    },
    concierge_order: {
    	cart: [],
    	custom: [],
    	promo_code: '',
    	date: new Date(),
    	experience: {
    		merchant: {},
    		cart: [],
    		date: new Date()
    	},
    	module: ''
    },
    room_stay: {},
		membership: {
			reward: {},
			referral: {}
		},
		reservation_active:{
			booking_number: '',
    	detail_id: '',
    	token: '',
    	folio: '',
			user_id: ''
		},
		promotion: {},
		be_promotion_filter: {
			id: '',
			names: {},
			is_membership: false,
			expired_at: ''
		},
    activeHotelModule: null,
    showAdditionalModuleInSearch: false,
    additionalServicePromotion: {}
	},
	getters: {
		getBeFilter: state => state.be_filter,
		getAgentId: state => state.agent_id,
		getBeFilterDetail: state => state.be_filter_detail,
		getBePrice: state => state.be_price,
		getBeSortBy: state => state.be_sort_by,
		getBeFirstLoad: state => state.be_first_load,
		getBeCart: state => state.trx_be,
		getBeCartRoom: state => state.trx_be.room_rate_details,
		getBeCartRoomCustom: state => state.trx_be.room_rate_custom,
		getBeCartRoomGuest: state => state.trx_be.room_rate_guest,
		getBeCartAddtService: state => state.trx_be.additional_service,
		getBeTicketOwner: state => state.trx_be.ticket_owner,
		getBeRoomTypeSummaryType(state) {
			let return_data = {
				is_villa: 0,
				is_room: 0,
			}
			for(let i = 0; i < state.trx_be.room_rate_details.length; i++){
				if(state.trx_be.room_rate_details[i].room_rate.room_type.type == 'VILLA'){
					return_data.is_villa++
				}else{
					return_data.is_room++
				}
			}

			if(return_data.is_villa > 0 && return_data.is_room > 0){
				return 'MIX'
			}else if(return_data.is_villa > 0 && return_data.is_room == 0){
				return 'VILLA'
			}else if(return_data.is_room > 0 && return_data.is_villa == 0){
				return 'ROOM'
			}else{
				return 'ROOM'
			}
		},
		getBeRoomSubTotal(state){
      const roomList = state.trx_be.room_rate_details;
      const GUEST = ['adult', 'child', 'infant'];
			let total = 0
      
      roomList.forEach(room => {
        const { dates } = room.room_rate;
        room.guest.forEach(guest => {
          let extraGuestPerNight = 0;
          
          dates.forEach(date => {
            const extraGuest = GUEST
            .map(key => Number(guest.extra[key])*Number(date.extra_guest[key].amount))
            .reduce((total, current) => total + current, 0);

            let basePrice = date.price;
            if(Vue.prototype.$isNotEmptyV3(guest.price_display)){
              basePrice = guest.price_display.price
            }
            
						extraGuestPerNight += (basePrice + extraGuest)
          })

          total += extraGuestPerNight
        })
      })
			return total
		},
		getBeRoomTotal(state){
      const roomList = state.trx_be.room_rate_details;
      const GUEST = ['adult', 'child', 'infant'];
			let total = 0
      
      roomList.forEach(room => {
        const { dates } = room.room_rate;
        room.guest.forEach(guest => {
          let totalPerNight = 0;
          
          dates.forEach(date => {
            const { extra_guest, price: defaultPrice, promotion_price: defaultPromotionPrice, taxes } = date;
            const extraGuest = GUEST
            .map(key => Number(guest.extra[key])*Number(extra_guest[key].amount))
            .reduce((total, current) => total + current, 0);

            let basePrice = {
              price: defaultPrice,
              promotion_price: defaultPromotionPrice
            };
            if(Vue.prototype.$isNotEmptyV3(guest.price_display)){
              basePrice = {
                price: guest.price_display.price,
                promotion_price: guest.price_display.promotion_price
              }
            }
            
						totalPerNight += (basePrice.price + basePrice.promotion_price + extraGuest)
          })

          total += totalPerNight
        })
      })
			return total;
		},
		getBeRoomSubTotalCustom(state){
			let total = 0
			for(let i = 0; i < state.trx_be.room_rate_custom.length; i++){
				let total_per_night = 0
				let total_addt_serv = 0
				for(let j = 0; j < state.trx_be.room_rate_custom[i].data.room_rate.dates.length; j++){
					total_per_night += state.trx_be.room_rate_custom[i].data.room_rate.dates[j].final_price
				}
				for(let addt_serv of state.trx_be.room_rate_custom[i].data.additional_service){
					total_addt_serv += addt_serv.total
				}
				total += (total_per_night+total_addt_serv)
			}
			return total
		},
		getBeRoomDeposit(state){
      const GUEST = ['adult', 'child', 'infant'];
      const rooms = state.trx_be.room_rate_details
			let total = 0;

      rooms.forEach(room => {
        const { 
          room_rate : { minimum_deposit_value: minDeposit, minimum_deposit_type: minDepositType, dates }, 
          guest: guestList 
        } = room;

        if(minDeposit <= 0) return;

        const isDepositByNight = minDepositType === 'NIGHT';
        guestList.forEach(guest => {
          if(isDepositByNight){
            let totalPerNight = 0;
            const isMinDepoLessThanDates = dates.length < minDeposit
            const totalNightDeposit = isMinDepoLessThanDates ? dates.length : minDeposit
            
            for (let i = 0; i < totalNightDeposit; i++) {
              const { 
                extra_guest, 
                price: defaultPrice, 
                promotion_price: defaultPromotionPrice, 
                taxes 
              } = dates[i];
              const extraGuest = GUEST
              .map(key => Number(guest.extra[key])*Number(extra_guest[key].amount))
              .reduce((total, current) => total + current, 0);

              let displayPrice = { price: defaultPrice, promotion_price: defaultPromotionPrice }
              if(Vue.prototype.$isNotEmptyV3(guest.price_display)){
                const { price, promotion_price } = guest.price_display;
                displayPrice = { price, promotion_price }
              }
              
              totalPerNight += (displayPrice.price + displayPrice.promotion_price + extraGuest)
            }
            total += totalPerNight
          }else{
            let totalPerNight = 0;
            dates.forEach(date => {
              const { 
                extra_guest, 
                price: defaultPrice, 
                promotion_price: defaultPromotionPrice, 
                taxes 
              } = date;
              const extraGuest = GUEST
              .map(key => Number(guest.extra[key])*Number(extra_guest[key].amount))
              .reduce((total, current) => total + current, 0);

              let displayPrice = { price: defaultPrice, promotion_price: defaultPromotionPrice }
              if(Vue.prototype.$isNotEmptyV3(guest.price_display)){
                const { price, promotion_price } = guest.price_display;
                displayPrice = { price, promotion_price }
              }
              
              totalPerNight += (displayPrice.price + displayPrice.promotion_price + extraGuest)
            })
            const depositPerNight = (totalPerNight*minDeposit)/100
            total += depositPerNight
          }
        })
      })
      
      return total;
		},
		getBeRoomDiscount(state){
			let total = 0
      const rooms = state.trx_be.room_rate_details

      rooms.forEach(room => {
        const { dates } = room.room_rate;
        room.guest.forEach(guest => {
          let totalPerNight = 0;
          
          dates.forEach(date => {
            const { promotion_price: defaultPromotionPrice } = date;
            const isPromotionByPax = Vue.prototype.$isNotEmptyV3(guest.price_display)
            const promotionPrice = isPromotionByPax ? guest.price_display.promotion_price : defaultPromotionPrice;
            
						totalPerNight += promotionPrice
          })

          total += totalPerNight
        })
      }) 
      
			return total
		},
		getBeAddtServiceSubTotal(state){
			let total = 0
			for(let i = 0; i < state.trx_be.additional_service.length; i++){
				total += (state.trx_be.additional_service[i].data.price * state.trx_be.additional_service[i].qty)
			}
			return total
		},
    getRoomAdditionalSubTotal(state){
      let total = 0;

      const savedRooms = state.trx_be.room_rate_details;
      savedRooms.forEach(room => {
        room.guest.forEach(guest => {
          if(Vue.prototype.$isNotEmptyV2(guest.products)){
            total += guest.products.reduce((sum,val) => (val.qty * Number(val.data.price)) + sum, 0);
          }
        })
      })

      return total;
    },
		getBeAddtServiceDeposit(state){
			let total = 0
			for(let addt_service of state.trx_be.additional_service){
				if(addt_service.data.minimum_deposit_percent > 0){
					let deposit = ((addt_service.data.price * addt_service.qty) * addt_service.data.minimum_deposit_percent) / 100
					total += deposit
				}
			}
			return total
		},
		getIsCartContact(state){
			let display = false
			if(state.trx_be.customer_details.first_name != '' && state.trx_be.customer_details.email != '' && state.trx_be.customer_details.phone_number != ''){
				display = true
			}
			return display
		},
		getIsCartContactEmail(state){
			const mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let email = false
			if(state.trx_be.customer_details.email.match(mailformat))
			{
				email = true
			}else{
				email = false
			}
				return email
		},
		getIsCartVisitor(state){
			let display = false
			if(state.trx_be.visitor_details.first_name != '' && state.trx_be.visitor_details.email != '' && state.trx_be.visitor_details.phone_number != ''){
				display = true
			}
			return display
		},
		getIsCartVisitorEmail(state){
			const mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let email = false
			if(state.trx_be.visitor_details.email.match(mailformat))
			{
				email = true
			}else{
				email = false
			}
				return email
		},
		getBeBypassCcGuarantee: state => {
			let need_cc_guarantee = true 
			let room = state.trx_be.room_rate_details
			for(let i = 0; i < room.length; i++){
				let room_date = room[i].room_rate.dates
				for(let j = 0; j < room_date.length; j++){
					if(room_date[j].promo_combine != null){
						let promo_list = room_date[j].promo_combine.promotion_list
						for (let k = 0; k < promo_list.length; k++) {
							if(promo_list[k].bypass_cc_guarantee){
								need_cc_guarantee = false
								break;
							}
						}
					}
					if(need_cc_guarantee) break;
				}
				if(need_cc_guarantee) break;
			}
			return need_cc_guarantee
		},
		getBeIsInvalIdPax: state => {
			let data = []
			state.trx_be.room_rate_details.forEach(room_rate=>{
				room_rate.guest.forEach(guest=>{
					let total_pax = Number(guest.included.adult)+Number(guest.included.child)+Number(guest.included.infant)
					if(total_pax == 0){
						data.push(room_rate)
					}					
				})
			})
			return data
		},
		getBeTxPayment: state => state.be_trx_payment,
		getBePayment: state => state.be_payment,
		getBeRoomAvbl: state => state.room_avbl,
		getConciergeAuth: state => state.concierge,
		getIsConciergeAuth: state => state.concierge.booking_number != '' && state.concierge.pin != '' ? true : false,
		getIsConciergeAuthWithoutPinToken: state =>   state.concierge.booking_number != '' &&  (state.concierge.pin == '' || (state.concierge.detail_id != '' && state.concierge.token == '')) ? true : false,
		getIsConciergeAuthWithPinOrToken: state =>   state.concierge.booking_number != '' &&  (state.concierge.pin != '' || (state.concierge.detail_id != '' && state.concierge.token != '')) ? true : false,
		getConciergeOrder: state => state.concierge_order,
		getConciergeOrderTotal(state){
			let total = 0
			for(let cart of state.concierge_order.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						let base_price = cart.product.variant_type == 'notes' ? cart.product.data.price : variant.data.price
						total += calculateFinalPriceConcierge(base_price) * variant.qty
					}
				}else{
					total += calculateFinalPriceConcierge(cart.product.data.price) * cart.qty
				}
			}

			return total
		},
		getConciergeOrderTotalTaxServices(state){
			let total = 0
			for(let cart of state.concierge_order.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						let base_price = cart.product.variant_type == 'basic' ? (variant.data.price.tax_amount+variant.data.price.service_amount) : (cart.product.data.price.tax_amount + cart.product.data.price.service_amount)
						total += base_price * variant.qty
					}
				}else{
					total += (cart.product.data.price.tax_amount + cart.product.data.price.service_amount) * cart.qty
				}
			}

			return total
		},
		getConciergeOrderTotalPromo(state){
			let total = 0
			for(let cart of state.concierge_order.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						if(cart.product.variant_type == 'basic'){
							if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'DECREASE'){
								total += variant.data.price.promotion_amount * variant.qty
							}
						}else{
							if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'DECREASE'){
								total += cart.product.data.price.promotion_amount * variant.qty
							}
						}
					}
				}else{
					if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'DECREASE'){
						total += cart.product.data.price.promotion_amount * cart.qty
					}
				}
			}

			return total
		},
		getConciergeOrderSubTotal(state){
			let total = 0
			for(let cart of state.concierge_order.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						if(cart.product.variant_type == 'basic'){
							if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'INCREASE'){
								total += (variant.data.price.price_sell+variant.data.price.promotion_amount) * variant.qty
							}else{
								total += variant.data.price.price_sell * variant.qty
							}
						}else{
							if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'INCREASE'){
								total += (cart.product.data.price.price_sell+cart.product.data.price.promotion_amount) * variant.qty
							}else{
								total += cart.product.data.price.price_sell * variant.qty
							}
						}
					}
				}else{
					if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'INCREASE'){
						total += (cart.product.data.price.price_sell+cart.product.data.price.promotion_amount) * cart.qty
					}else{
						total += cart.product.data.price.price_sell * cart.qty
					}
				}
			}
			return total
		},
		getConciergeOrderCustomTotal(state){
			let total = 0
			for(let cart of state.concierge_order.custom){
				total += cart.product.price_sell * cart.form.qty
			}
			return total
		},
		getConciergeReservation: state => state.concierge_reservation,
		getConciergeOrderExperienceSubTotal(state){
			let total = 0
			for(let cart of state.concierge_order.experience.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'INCREASE'){
							total += (variant.data.price.price_sell+variant.data.price.promotion_amount) * variant.qty
						}else{
							total += variant.data.price.price_sell * variant.qty
						}
					}
				}else{
					if(cart.product.data.price.promotion_amount > 0 && cart.product.data.price.promotion_type == 'INCREASE'){
						total += (cart.product.data.price.price_sell+cart.product.data.price.promotion_amount) * cart.qty
					}else{
						total += cart.product.data.price.price_sell * cart.qty
					}
				}
			}
			return total
		},
		getConciergeOrderExperienceTotalTaxServices(state){
			let total = 0
			for(let cart of state.concierge_order.experience.cart){
				if(cart.product.is_variant){
					for(let variant of cart.variant){
						total += (variant.data.price.tax_amount+variant.data.price.service_amount) * variant.qty
					}
				}else{
					total += (cart.product.data.price.tax_amount + cart.product.data.price.service_amount) * cart.qty
				}
			}

			return total
		},
		getRoomStay: state => state.room_stay,
		getMembershipRewardApplied: state => state.membership.reward,
		isMembershipRewardApplied: state => store.getters.isLoggedIn && state.membership.reward.id ? true : false,
		getMembershipReferral: state => state.membership.referral,
		getReservationActive: state => state.reservation_active,
		isReservationActive: state => state.reservation_active.booking_number != '' && state.reservation_active.detail_id != '',
		isCurrentUserSameWithRsvUser: state => store.getters.isLoggedIn && state.reservation_active.user_id == store.getters.getCurrentUser.id,
		isUnderSearchPax: state => {
			const savedRooms = state.trx_be.room_rate_details;
      if (!savedRooms.length) return null;

      const initialGuestCounts = { total: 0, adult: 0, child: 0, infant: 0 };

      let showSpecificGuest = false;
      const roomsMaxGuests = savedRooms.reduce((acc, { room_rate: { rate, room_type }, qty }) => {
        const { use_max_guest_by_pax = false, max_guests = null, max_guest_adult = 0, max_guest_children = 0, max_guest_infant = 0 } = rate.max_guests ? rate : room_type;
        
        if (use_max_guest_by_pax) {
          acc.adult += (Number(max_guest_adult) * Number(qty));
          acc.child += (Number(max_guest_children) * Number(qty));
          acc.infant += (Number(max_guest_infant) * Number(qty));
          showSpecificGuest = true
        }
        acc.total += (Number(max_guests) * Number(qty));
        
        return acc;
      }, initialGuestCounts);
      
      const filterGuest = { ...state.be_filter.guest };
      const totalSavedGuest = savedRooms
      .flatMap(room => room.guest)
      .reduce((acc, guest) => {
        ['included', 'extra'].forEach(key => {
          Object.entries(guest[key]).forEach(([type, count]) => {
            acc[type] = (Number(acc[type]) || 0) + Number(count);
          });
        });
        return acc;
      }, {});

      if(showSpecificGuest){

        let remainingGuestText = []
        for (const [key, value] of Object.entries(filterGuest)) {
          const remainingGuest = Number(value) - Number(totalSavedGuest[key])
          if (remainingGuest > 0) {
            remainingGuestText.push(`${remainingGuest} ${key}`);
          }
        }

        if(remainingGuestText.length === 0) return null;
        return `Need more rooms for: ${remainingGuestText.join(', ')}`;
      }else{
        const totalRemainingGuest = Object.values(filterGuest).reduce((sum, value) => sum + Number(value), 0)
        const totalSavedGuests = Object.values(totalSavedGuest).reduce((sum, value) => sum + Number(value), 0)
        const remainingGuestFilter = Number(totalRemainingGuest) - Number(totalSavedGuests);
        return remainingGuestFilter <= 0 ? null : `Need more rooms for ${Number(remainingGuestFilter)} guest`;
      }
		},
		getSelectedPromotion: state => state.promotion,
    is_under_search_pax: state => {
			let rooms = state.trx_be.room_rate_details
			let filter = state.be_filter
			let data = {show:false,data:0}
			if(rooms.length > 0){
				let total_room_guest = 0
				rooms.forEach(room => {
					let {room_rate: {rate,room_type}, qty} = room
					let max_guest = rate.max_guests ? rate.max_guests : room_type.max_guests
          total_room_guest += (max_guest*qty)
				})
        const { adult, child, infant } = filter.guest;
        let total_guest = Number(adult) + Number(child) + Number(infant);
				if(total_room_guest<total_guest) data = {show:true,data:total_guest-total_room_guest}
			}
			return data
		},
		getSelectedPromotion: state => state.promotion,
		getBePromotionFilterId: state => {
			const promotionFilter = state.be_promotion_filter;
			if(!promotionFilter || !promotionFilter.id) return '';
			const isExpired = moment().utc().isAfter(promotionFilter.expired_at);
			return isExpired ? '' : promotionFilter.id;
		},
		getBePromotionFilterName: (state, getters, rootState, rootGetters) => {
			if(!getters.getBePromotionFilterId) return '';
			const { names, name } = state.be_promotion_filter;
			// filters persisted before names existed only carry the name picked at link time
			const hasNames = names && Object.keys(names).length > 0;
			return getPromotionName(hasNames ? names : { name }, rootGetters.getCurrentLanguage);
		},
		isBePromotionFilterMembership: (state, getters) => {
			if(!getters.getBePromotionFilterId) return false;
			return state.be_promotion_filter.is_membership === true;
		},
    getActiveHotelModule: state => state.activeHotelModule,
    iActiveHotelModuleRoom: state => !state.activeHotelModule || state.activeHotelModule.id === 'room',
    getShowAdditionalModuleInSearch: state => state.showAdditionalModuleInSearch,
    getAdditionalServicePromotion: state => state.additionalServicePromotion
	},
	mutations: {
		setBeFilter(state, payload){
      const selectedPromotion = state.promotion 
      if(selectedPromotion && state.be_filter && state.be_filter.promo_code === selectedPromotion.promo_code) {
        state.promotion = {};
      }

      state.be_filter = payload
		},
		setSpecificBeFilter(state,payload){
			for (let param of payload){
				state.be_filter[param.key] = param.value
			}
		},
		setAgentId(state, payload){
			state.agent_id = payload
		},
		setBeFilterDetail(state, payload){
			state.be_filter_detail = payload
		},
		setBePrice(state, payload){
			state.be_price = payload
		},
		setBeSortBy(state, payload){
			state.be_sort_by = payload
		},
		resetBeFilter(state,payload){
			state.be_filter = {
				date: {
					check_in: new Date(),
					check_out: moment().add(store.getters.getMerchant.search_room_filter_default_total_night,'d').toDate(),
				},
				guest: {
					adult: store.getters.getMerchant.search_room_filter_default_total_adult,
					child: 0,
					infant: 0,
				},
				promo_code: '',
			}
			state.be_price= [0,0]
	    state.be_sort_by= 'room_type'
	  },
		setBeFirstLoad(state,payload){
			state.be_first_load = payload
		},
		BeManipulateRoomRate(state,payload){
			if(payload == 'reset'){
				state.trx_be.room_rate_details = []
				state.trx_be.qty.room_rate = 0
			}else{
				let record = false
				record  = state.trx_be.room_rate_details.find(prms=>prms.room_rate.id == payload.room_rate.id)
				if(!record){
					state.trx_be.room_rate_details.push(payload)
					state.trx_be.qty.room_rate += parseInt(payload.qty) 
				}else{
					state.trx_be.qty.room_rate -= record.qty
					record.qty = parseInt(payload.qty)
					state.trx_be.qty.room_rate += parseInt(payload.qty)

				}
			}
		},
		beRemoveRoomRate(state,payload){
			let record = false
			record  = state.trx_be.room_rate_details.findIndex(prms=>prms.room_rate.id == payload)
			if(record != -1){
				state.trx_be.qty.room_rate -= state.trx_be.room_rate_details[record].qty
				state.trx_be.room_rate_details.splice(record,1)
			}else{
				console.error("Room rate not found")
			}
		},
    // Delete rooms per qty (1 qty room = 1 reservation)
    BeRemoveReservation(state, payload){
      const { roomId, guestIndex } = payload;

      const savedRoomIndex = state.trx_be.room_rate_details.findIndex(room => room.room_rate.id === roomId);

      if(savedRoomIndex === -1) {
        console.error("ROOM RATE NOT FOUND");
        return;
      }

      const selectedRoom = state.trx_be.room_rate_details[savedRoomIndex];
      state.trx_be.qty.room_rate -= selectedRoom.qty
      
      const isLastReservation = selectedRoom.guest.length === 1;
      if(isLastReservation){
        state.trx_be.room_rate_details.splice(savedRoomIndex,1);
        return;
      }

      state.trx_be.room_rate_details[savedRoomIndex].guest.splice(guestIndex, 1);
      state.trx_be.room_rate_details[savedRoomIndex].qty -= 1;
      
    },
		BeManipulateRoomRateGuest(state,payload){
			let record  = state.trx_be.room_rate_details.findIndex(prms=>prms.room_rate.id == payload.id)
			if(record != -1){
				let guests = state.trx_be.room_rate_details[record].guest
				const { dates, rate: { guest_included: defaultGuestIncluded } } = state.trx_be.room_rate_details[record].room_rate

        const handlePerGuest = (guestIndex, useSameIndexForPayload = true) => {
          const guestPayloadIndex = useSameIndexForPayload ? guestIndex : 0;
          
          state.trx_be.room_rate_details[record].guest[guestIndex].included = payload.guest.included[guestPayloadIndex]
					state.trx_be.room_rate_details[record].guest[guestIndex].extra = payload.guest.extra[guestPayloadIndex]

          if(Vue.prototype.$isNotEmptyV3(payload.guest_age)){
            const GUEST_NEED_AGE = ['child','infant'];
            GUEST_NEED_AGE.forEach(gst => {
              if(Vue.prototype.$isNotEmptyV3(payload.guest_age[gst])){
                const currentGuest = state.trx_be.room_rate_details[record].guest[guestIndex];

                let guestAge = {}
                if(Vue.prototype.$isEmpty(currentGuest.age)){
                  guestAge = {
                    [gst]: payload.guest_age[gst][guestPayloadIndex]
                  }
                }else if(Vue.prototype.$isEmpty(currentGuest.age[gst])){
                  guestAge = {
                    ...currentGuest.age,
                    [gst]: payload.guest_age[gst][guestPayloadIndex]
                  }
                }else{
                  guestAge = currentGuest.age;
                  guestAge[gst] = payload.guest_age[gst][guestPayloadIndex]
                }
                
                state.trx_be.room_rate_details[record].guest[guestIndex] = {
                  ...currentGuest,
                  age: guestAge
                };
              }
            })
          }

          const useReducePriceByPax = Vue.prototype.$isNotEmptyV2(dates[0].price_per_guest);
          if(useReducePriceByPax){
            const guestList = state.trx_be.room_rate_details[record].guest
            const currentGuest = guestList[guestIndex]
            const currentGuestIncluded = Object.values(currentGuest.included).reduce((sum, val) => sum + val, 0)
            const { price, promotion } = Vue.prototype.$calculatePriceByPax(currentGuestIncluded, dates[0], defaultGuestIncluded) 

            Vue.set(guestList, guestIndex, {
              ...currentGuest,
              price_display: {
                price,
                promotion_price: promotion,
              },
            })
          }
        }
        
        if(Vue.prototype.$isNotEmptyV2(payload.guest_index)){
          handlePerGuest(payload.guest_index, false);
        }else{
          guests.forEach((item,index)=>{
            handlePerGuest(index);
          })
        }

				let final_data = {
					total_extra_guest_price: 0,
					extra_guest:{
						adult:0,
						child:0,
						infant:0
					}
				}

				state.trx_be.room_rate_details[record].guest.forEach((item,guest_index)=>{
					let dates = state.trx_be.room_rate_details[record].room_rate.dates
					let extra_guest_price = dates[0].extra_guest
					final_data.total_extra_guest_price += (item.extra.adult*extra_guest_price.adult.amount) + (item.extra.child*extra_guest_price.child.amount) + (item.extra.infant*extra_guest_price.infant.amount)
					final_data.extra_guest.adult += item.extra.adult
					final_data.extra_guest.child += item.extra.child
					final_data.extra_guest.infant += item.extra.infant
				})
				
				dates.forEach((item,index)=>{
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest_price = final_data.total_extra_guest_price
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.total = final_data.total_extra_guest_price
					state.trx_be.room_rate_details[record].room_rate.dates[index].final_price = dates[index].price + dates[index].promotion_price + final_data.total_extra_guest_price

					let obj_extra = state.trx_be.room_rate_details[record].room_rate.dates[index]
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.adult.qty = final_data.extra_guest.adult
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.adult.total = final_data.extra_guest.adult*obj_extra.extra_guest.adult.amount
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.child.qty = final_data.extra_guest.child
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.child.total = final_data.extra_guest.child*obj_extra.extra_guest.child.amount
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.infant.qty = final_data.extra_guest.infant
					state.trx_be.room_rate_details[record].room_rate.dates[index].extra_guest.infant.total = final_data.extra_guest.infant*obj_extra.extra_guest.infant.amount
				})
				
			}else{
				console.error("ROOM RATE NOT FOUND")
			}
		},
    saveAdditionalProductToRoom(state, payload){
      const { roomId, guestIndex, product, qty } = payload
      const savedRoomIndex = state.trx_be.room_rate_details.findIndex(room => room.room_rate.id === roomId);

      if(savedRoomIndex === -1) {
        console.error("ROOM RATE NOT FOUND");
        return;
      }
      
      const newProduct = {data: product, qty};
      const selectedRoom = state.trx_be.room_rate_details[savedRoomIndex];
      
      if(Vue.prototype.$isEmpty(selectedRoom.guest[guestIndex].products)){
        if(qty > 0){
          Vue.set(state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex], 'products', [newProduct])
        }
        return;
      } 

      const selectedProduct = selectedRoom.guest[guestIndex].products.findIndex(prd => prd.data.id === product.id);

      if(selectedProduct === -1){
        if(qty > 0){
          state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex].products.push(newProduct)
        }
        return;
      }

      if(qty > 0){
        Vue.set(state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex].products, selectedProduct, newProduct)
      }else{
        state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex].products.splice(selectedProduct, 1);
      }
      
    },
    removeAdditionalProductToRoom(state, payload){
      const { roomId, guestIndex, productId } = payload;
      
      const savedRoomIndex = state.trx_be.room_rate_details.findIndex(room => room.room_rate.id === roomId);

      if(savedRoomIndex === -1) {
        console.error("ROOM RATE NOT FOUND");
        return;
      }

      const selectedRoom = state.trx_be.room_rate_details[savedRoomIndex];
      
      const savedProductIndex = selectedRoom.guest[guestIndex].products.findIndex(product => product.data.id === productId);

      if(savedProductIndex === -1) {
        console.error("PRODUCT NOT FOUND");
        return;
      }
      
      state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex].products.splice(savedProductIndex, 1);
    },
    saveTransportDataPerRoom(state, payload){
      const { roomId, guestIndex, routeType, key, value } = payload;
      
      const savedRoomIndex = state.trx_be.room_rate_details.findIndex(room => room.room_rate.id === roomId);

      if(savedRoomIndex === -1) {
        console.error("ROOM RATE NOT FOUND");
        return;
      }

      const selectedRoom = state.trx_be.room_rate_details[savedRoomIndex];

      if(Vue.prototype.$isEmpty(selectedRoom.guest[guestIndex][routeType])){
        Vue.set(state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex], routeType , {})
      }

      Vue.set(state.trx_be.room_rate_details[savedRoomIndex].guest[guestIndex][routeType], key , value)
    },
		beReplaceDataRoomRate(state,payload){
			let record = false
			record  = state.trx_be.room_rate_details.findIndex(prms=>prms.room_rate.id_ori == payload.id_ori)
			if(record != -1){
				let old_rr = structuredClone(state.trx_be.room_rate_details[record].room_rate)
				state.trx_be.room_rate_details[record].room_rate = payload

				// REPLACE BASE PRICE & CONFIG
				state.trx_be.room_rate_details[record].room_rate.dates = state.trx_be.room_rate_details[record].room_rate.dates.map((x,i)=>{
					let return_data = x
					x.extra_guest_price = old_rr.dates[i].extra_guest_price
					x.final_price = old_rr.dates[i].final_price
					x.extra_guest = old_rr.dates[i].extra_guest
					return return_data
				}) 
			}else{
				console.error("Room rate not found")
			}
		},
		BeManipulateRoomRateCustom(state,payload){
			let rr_length = state.trx_be.room_rate_custom.length
			let params = {
				id: rr_length == 0 ? 1 : state.trx_be.room_rate_custom[rr_length-1].id+1,
				data: payload
			}
			state.trx_be.room_rate_custom.push(params)
		},
		beRemoveRoomRateCustom(state,payload){
			let record  = state.trx_be.room_rate_custom.findIndex(prms=>prms.id == payload)
			if(record != -1){
				state.trx_be.room_rate_custom.splice(record,1)
			}else{
				console.log("CUSTOM CART ITEM NOT FOUND")
			}
		},
		BeAddAddtServiceCustom(state,payload){
			let record = state.trx_be.room_rate_custom.findIndex(prms=>prms.id == payload.id)
			if(record != -1){
				state.trx_be.room_rate_custom[record].data.additional_service = payload.data
			}else{
				console.log("CUSTOM CART ITEM NOT FOUND")
			}
		},
		BeManipulateAddtService(state,payload){
			if(payload == 'reset'){
				state.trx_be.additional_service = []
				state.trx_be.qty.additional = 0
			}else{
				let record = false
				record  = state.trx_be.additional_service.findIndex(prms=>prms.data.id == payload.data.id)
				if(record == -1){
					state.trx_be.additional_service.push({
						data: payload.data,
						qty: 1
					})
					state.trx_be.qty.additional_service++
				}else{
					// if increment
					if(payload.qty == 1){
						state.trx_be.additional_service[record].qty++
						state.trx_be.qty.additional_service++
					}else{
						// if 1 qty left in vuex
						if(state.trx_be.additional_service[record].qty == 1){
							state.trx_be.additional_service.splice(record,1)
						}else{
							state.trx_be.additional_service[record].qty--
						}
						state.trx_be.qty.additional_service--
					}
				}
			}
		},
    BeSaveOtherDataAddtService(state,payload){
      const { key, value, detail } = payload;
      const savedProductIndex = state.trx_be.additional_service.findIndex(product => product.data.id === detail.id);
      if(savedProductIndex === -1) return;

      Vue.set(state.trx_be.additional_service[savedProductIndex], key, value);
    },
		BeRemoveAddtService(state,payload){
			let product_in_cart = state.trx_be.additional_service.findIndex(x=>x.data.id==payload.id)
			if(product_in_cart != -1){
				let temp_qty = state.trx_be.additional_service[product_in_cart].qty
				state.trx_be.additional_service.splice(product_in_cart,1)
				state.trx_be.qty.additional_service -= temp_qty
			}
		},
		BeManipulateSpecialReq(state,payload){
			state.trx_be.special_request = payload.special_request
			state.trx_be.custom_time = payload.time
			state.trx_be.note = payload.note
		},
		setBeCustomer(state,payload){
			state.trx_be.customer_details = payload
		},
		setBeVisitor(state,payload){
			state.trx_be.visitor_details = payload
		},
		setBeGuestData(state,payload){
			for (let param of payload.data){
				state.trx_be[payload.field][param.key] = param.value
			}
		},
		setBeTicketOwner(state,payload){
			state.trx_be.ticket_owner = payload
		},
		resetBECart(state,payload){
			state.trx_be = {
	    	room_rate_details: [],
	    	room_rate_guest: [],
	    	room_rate_custom: [],
	    	customer_details: {
	    		first_name: "",
					last_name: "",
					phone_number: "",
					email: "",
					address: "",
					title: "",
					country: "",
					nationality: "",
					day_of_birth: ""
	    	},
	    	visitor_details: {
	    		first_name: "",
					last_name: "",
					phone_number: "",
					email: "",
					address: "",
					title: "",
					country: "",
					nationality: "",
					day_of_birth: ""
	    	},
	    	ticket_owner: 'me',
	    	additional_service: [],
	    	special_request: [],
	    	qty: {
	    		room_rate: 0,
	    		additional_service: 0
	    	},
	    	custom_time:{
	    		check_in: '',
	    		check_out: ''
	    	},
	    	note: ''
	    }
		},
		setBePayment(state,payload){
			state.be_payment = payload
		},
		setRoomGuest(state,payload){
			if(payload.type == 'all'){
				state.trx_be.room_rate_guest = payload.data
			}else{
				let record = state.trx_be.room_rate_guest.findIndex(x=>x.room_id == payload.room_id)
				if(record != -1){
					state.trx_be.room_rate_guest[record].data = payload.data
				}else{
					console.log("ERROR : ROOM ID NOT FOUND")
				}
			}
		},
		setBeRoomAvbl(state,payload){
			let temp_data = payload
			// loop payload
			temp_data.forEach((room_avbl,first_index)=>{
				if(room_avbl.availability == 0){
					// cek pada cart
					state.trx_be.room_rate_details.forEach((cart_item,cart_index)=>{
						// hapus room type pada cart jika ada
						if(cart_item.room_rate.room_type.id == room_avbl.id){
							state.trx_be.room_rate_details.splice(cart_index,1)
						}

						// jika room type bukan virtual namun memiliki room affected lebih dari 0 maka room affectednya perlu dihapus dari cart juga
						if(!room_avbl.is_virtual && room_avbl.availability_affected.length>0){
							let rt_affected_cart = room_avbl.availability_affected.findIndex(x=>x.id == cart_item.room_rate.room_type.id)
							if(rt_affected_cart != -1){
								state.trx_be.room_rate_details.splice(cart_index,1)
							}
						}
					})
					/*jika room type bukan virtual namun memiliki room affected lebih dari 0 maka room affectednya perlu di set avlb = 0*/
					if(!room_avbl.is_virtual && room_avbl.availability_affected.length>0){
						// set availability dari setiap availability_affected menjadi 0
						room_avbl.availability_affected.forEach((affected_item,affected_index)=>{
							let virtual_affected_index = temp_data.findIndex(x=>x.id == affected_item.id)
							if(virtual_affected_index != -1){
								temp_data[virtual_affected_index].availability = 0
							}
						})
					}
				}else{
					// cek apakah room type virtual?
					if(room_avbl.is_virtual){
						// perulangan untuk room affectednya
						let is_parent_in_cart = false
						room_avbl.availability_affected.forEach((room_avbl_afft,room_avbl_afft_i)=>{
							// cek apakah room affectednya terdapat pada payload
							let rt_affected = temp_data.findIndex(x=>x.id == room_avbl_afft.id)
							if(rt_affected != -1){
								// jika avbl room affectednya 0 maka set avbl room parent nya menjadi 0 juga
								if(temp_data[rt_affected].availability == 0){
									temp_data[first_index].availability = 0
									// jika avbl room affectednya memiliki room affected lebih dari 1 yang artinya memiliki lebih dari 1 parent
									if(temp_data[rt_affected].availability_affected.length>1){
										// perulangan untuk room affectednya
										temp_data[rt_affected].availability_affected.forEach(affected_parent=>{
											// validasi hanya untuk yang bukan parent saat ini
											if(affected_parent.id != room_avbl.id){
												let virtual_affected_index_child = temp_data.findIndex(x=>x.id == affected_parent.id)
												if(virtual_affected_index_child != -1){
													temp_data[virtual_affected_index_child].availability = 0
												}
											}
										})
									}
								}else{
									// cek apakah room affectednya ada di cart? jika iya maka set avbl semua parentnya menjadi 0
									let cart_rt_avblb =  state.trx_be.room_rate_details.findIndex(x=>x.room_rate.room_type.id == room_avbl_afft.id)
									if(cart_rt_avblb != -1){
										temp_data[first_index].availability = 0
										// jika avbl room affectednya memiliki room affected lebih dari 1 yang artinya memiliki lebih dari 1 parent
										if(temp_data[rt_affected].availability_affected.length>1){
											// perulangan untuk room affectednya
											temp_data[rt_affected].availability_affected.forEach(affected_parent=>{
												// validasi hanya untuk yang bukan parent saat ini
												if(affected_parent.id != room_avbl.id){
													let virtual_affected_index_parent = temp_data.findIndex(x=>x.id == affected_parent.id)
													if(virtual_affected_index_parent != -1){
														temp_data[virtual_affected_index_parent].availability = 0
													}
												}
											})
										}
									}
									if(room_avbl_afft_i+1 === room_avbl.availability_affected.length){
										let parent_in_cart = state.trx_be.room_rate_details.findIndex(x=>x.room_rate.room_type.id == room_avbl.id)
										if(parent_in_cart != -1){
											room_avbl.availability_affected.forEach((room_avbl_afft_b)=>{
												let rt_affected_b = temp_data.findIndex(x=>x.id == room_avbl_afft_b.id)
												if(rt_affected_b != -1 && temp_data[rt_affected_b].availability_affected.length>1){
													temp_data[rt_affected_b].availability_affected.forEach((room_avbl_afft_c)=>{
														if(room_avbl_afft_c.id != room_avbl.id){
															let rt_affected_c = temp_data.findIndex(x=>x.id == room_avbl_afft_c.id)
															if(rt_affected_c != -1){
																temp_data[rt_affected_c].availability = 0
															}
														}
													})
												}
											})
										}
									}
								}
							}
						})
					}else if(!room_avbl.is_virtual && room_avbl.availability_affected.length>0){
						// lakukan pengecekan pada cart apakah ada room parent atau tidak
						let virtual_affected_index = state.trx_be.room_rate_details.findIndex(x=>x.room_rate.room_type.id == room_avbl.availability_affected[0].id)
						if(virtual_affected_index != -1){
							temp_data[first_index].availability = 0
							if(room_avbl.availability_affected.length>1){
								room_avbl.availability_affected.forEach((affected_item,affected_index)=>{
									if(affected_index>0){
										let virtual_affected_index_child = temp_data.findIndex(x=>x.id == affected_item.id)
										if(virtual_affected_index_child != -1){
											temp_data[virtual_affected_index_child].availability = 0
										}
									}
								})
							}	
						}
					}else{
						state.trx_be.room_rate_details.forEach((room_rate,room_rate_index)=>{
							if(room_rate.room_rate.room_type.id == room_avbl.id){
								if(temp_data[first_index].availability >= room_rate.qty){
									temp_data[first_index].availability -=  room_rate.qty
								}else{
									state.trx_be.room_rate_details.splice(room_rate_index,1)
								}
							}
						})
					}
				}
			})
			state.room_avbl = temp_data
		},
		/* Partial-payload counterpart of setBeRoomAvbl, for the digital map popup
		   which searches one room_type_id at a time: a full replace there would
		   wipe the availability of every other room type and prune their cart
		   rows. The virtual / availability_affected handling above is deliberately
		   not repeated -- this only ever receives a single room type. */
		mergeBeRoomAvbl(state,payload){
			if(!Array.isArray(payload) || payload.length == 0) return

			let merged = state.room_avbl.slice()

			payload.forEach((room_avbl)=>{
				let incoming = Object.assign({}, room_avbl)

				/* search-room reports raw inventory; rooms the guest already holds
				   in the cart are subtracted here so $roomAvbl can add back the qty
				   of the one rate it is asked about. Looping backwards because a
				   cart row can be spliced out mid-loop. */
				for(let i = state.trx_be.room_rate_details.length - 1; i >= 0; i--){
					let cart_item = state.trx_be.room_rate_details[i]
					if(cart_item.room_rate.room_type.id != incoming.id) continue
					if(incoming.availability >= cart_item.qty){
						incoming.availability -= cart_item.qty
					}else{
						state.trx_be.room_rate_details.splice(i,1)
					}
				}

				let existing_index = merged.findIndex(x=>x.id == incoming.id)
				if(existing_index != -1){
					merged[existing_index] = incoming
				}else{
					merged.push(incoming)
				}
			})

			state.room_avbl = merged
		},
		changeBeRoomAvbl(state,payload){
			// payload = {
			// 	id: 'xxxxx',
			// 	qty: 1,
			// 	action: 'inc/dec',
			// 	is_virtual: false/true,
			// 	availability_affected: []
			// }
			let record = state.room_avbl.findIndex(x=>x.id == payload.id)
			if(record != -1){

				let record_rr = state.trx_be.room_rate_details.findIndex(x=>x.room_rate.id == payload.rr_id)
				let old_qty = 0
				if(record_rr != -1){
          old_qty = state.trx_be.room_rate_details[record_rr].qty
				}

				if(payload.action == 'inc'){
					state.room_avbl[record].availability -= old_qty
					state.room_avbl[record].availability += payload.qty
				}else{
					state.room_avbl[record].availability += old_qty
					state.room_avbl[record].availability -= payload.qty
				}
			}
			payload.availability_affected.forEach(item=>{
				let record_a = state.room_avbl.findIndex(x=>x.id == item.id)
				if(record_a != -1){
					state.room_avbl[record_a].availability = payload.action == 'dec' ? 0 : state.room_avbl[record_a].original_availability
					if(payload.is_virtual){
						state.room_avbl[record_a].availability_affected.forEach(item_child=>{
							let record_b = state.room_avbl.findIndex(x=>x.id == item_child.id)
							if(record_b != -1){
								state.room_avbl[record_b].availability = payload.action == 'dec' ? 0 : state.room_avbl[record_b].original_availability
							}
						})
					}
				}
			})
		},
		setBeTxPayment(state,payload){
			state.be_trx_payment = payload
		},
		setConciergeAuth(state,payload){
			for (let param of payload){
				state.concierge[param.key] = param.value
			}
		},
		resetConciergeAuth(state){
			state.concierge = {
				booking_number: '',
	    	pin: '',
	    	token: '',
	    	folio: '',
	    	detail_id: '',
	    	pin_applied: false
			}
			state.concierge_reservation = {
	    	status: '',
	    	guest_profile: {},
	    	room: {}
	    }
			state.room_stay = {}
		},
		setConciergeOrder(state,payload){
			// find product in list
			let record_product = state.concierge_order.cart.findIndex(product=> product.product.data.id == payload.product.id)

			// if product not found
			if(record_product == -1){
				let is_variant_basic = payload.product.variant_list.length > 0
				let is_variant = is_variant_basic ? true : payload.product.use_variant_notes 
				let copied_data = JSON.parse(JSON.stringify(payload))
				if(is_variant_basic){
					delete copied_data.variant.tax_services
				}
				delete copied_data.product.variant_list
				let data = {
					product: {
						data: copied_data.product,
						is_variant: is_variant,
						variant_type: is_variant ? is_variant_basic ? 'basic' : 'notes' : ''
					},
					variant: !is_variant ? [] : [{
						data: copied_data.variant,
						qty: payload.qty,
						notes: ''
					}],
					notes: '',
					qty: payload.qty
				}

				state.concierge_order.cart.push(data)
			}else{
				if(state.concierge_order.cart[record_product].product.is_variant){
					// find variant in product list car
					let record_variant = state.concierge_order.cart[record_product].variant.findIndex(variant => state.concierge_order.cart[record_product].product.variant_type == 'basic' ? variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id : variant.data == payload.variant)

					// if variant is matches instead product list
					if(record_variant != -1){

						state.concierge_order.cart[record_product].qty -= state.concierge_order.cart[record_product].variant[record_variant].qty

						state.concierge_order.cart[record_product].variant[record_variant].qty = payload.qty

						state.concierge_order.cart[record_product].qty += state.concierge_order.cart[record_product].variant[record_variant].qty
					}else{
						let copied_data_variant = payload.product.variant_type == 'basic' ? JSON.parse(JSON.stringify(payload.variant)) : payload.variant
						if(payload.product.variant_type == 'basic'){
							delete copied_data_variant.tax_services
						}
						state.concierge_order.cart[record_product].variant.push({
							data: copied_data_variant,
							notes: '',
							qty: payload.qty
						})
						state.concierge_order.cart[record_product].qty += payload.qty
					}
				}else{
					state.concierge_order.cart[record_product].qty = payload.qty
				}	
			}
		},
		setConciergeOrderNote(state,payload){
			// payload = {
			// 	product_id: '',
			// 	variant_id: '',
			// 	notes: ''
			// }
			let record_p = state.concierge_order.cart.findIndex(product=> product.product.data.id == payload.product_id)
			if(record_p == -1){
				console.log("ERROR WHILE ADDING NOTE : PRODUCT NOT FOUND")
			}else{
				if(payload.variant_id == ''){
					state.concierge_order.cart[record_p].notes = payload.notes
				}else{
					let record_v = state.concierge_order.cart[record_p].variant.findIndex(variant=> payload.variant_id == 'variant_notes' ? variant.data == payload.variant_notes_id : variant.data.id == payload.variant_id)
					if(record_v == -1){
						console.log("ERROR WHILE ADDING NOTE : VARIANT NOT FOUND")
					}else{
						state.concierge_order.cart[record_p].variant[record_v].notes = payload.notes
					}
				}
			}

		},
		setSpecificConcierOrder(state,payload){
			let cart_product = state.concierge_order.cart[payload.index_product]
			if(payload.is_variant){
				let cart_variant = cart_product.variant[payload.index_variant]
				if(cart_variant.data.promotion_affected.best == null || (cart_variant.data.promotion_affected.best != null && cart_variant.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
					cart_variant.old_data = JSON.parse(JSON.stringify(cart_variant.data))
				}
				cart_variant.data = payload.data
			}else{
				if(cart_product.product.data.promotion_affected.best == null || (cart_product.product.data.promotion_affected.best != null && cart_product.product.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
					cart_product.product.old_data = JSON.parse(JSON.stringify(cart_product.product.data))
				}
				cart_product.product.data = payload.data
			}
		},
		resetSpecificConciergeOrder(state,payload){
			let cart_product = state.concierge_order.cart[payload.index_product]
			if(payload.is_variant){
				cart_product.variant[payload.index_variant].data = JSON.parse(JSON.stringify(cart_product.variant[payload.index_variant].old_data))
				delete cart_product.variant[payload.index_variant].old_data
			}else{
				cart_product.product.data = JSON.parse(JSON.stringify(cart_product.product.old_data))
				delete cart_product.product.old_data
			}
		},
		removeConciergeOrder(state,payload){
			let record_product = state.concierge_order.cart.findIndex(product=> product.product.data.id == payload.product.id)
			if(record_product != -1){
				let is_variant = state.concierge_order.cart[record_product].product.is_variant
				if(is_variant){
					let record_variant = state.concierge_order.cart[record_product].variant.findIndex(variant => state.concierge_order.cart[record_product].product.variant_type == 'basic' ? variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id : variant.data == payload.variant)
					if(record_variant != -1){
						let temp_variant = state.concierge_order.cart[record_product].variant[record_variant].qty
						state.concierge_order.cart[record_product].variant.splice(record_variant,1)
						if(state.concierge_order.cart[record_product].variant.length == 0){
							state.concierge_order.cart.splice(record_product,1)
						}else{
							state.concierge_order.cart[record_product].qty -= temp_variant
						}
					}
				}else{
					state.concierge_order.cart.splice(record_product,1)
				}
			}
		},
		removeOneConciergeOrder(state,payload){
			// payload = product.id
			let record_product = state.concierge_order.cart.findIndex(product=> product.product.data.id == payload)
			if(record_product != -1){
				state.concierge_order.cart.splice(record_product,1)
			}
		},
		setConciergeOrderCustom(state,payload){
			// find product in list
			let record_product = state.concierge_order.custom.findIndex(data=> data.product.id == payload.product.id)
			if(record_product == -1){
				state.concierge_order.custom.push(payload)
			}else{
				state.concierge_order.custom[record_product] = payload
			}
		},
		setConciergeOrderDate(state,payload){
			state.concierge_order.date = payload
		},
		setUpdateConciergeOrderCustom(state,payload){
			// find product in list
			let record_product = state.concierge_order.custom.findIndex(data=> data.product.id == payload.product.id)
			if(record_product == -1){
				state.concierge_order.custom.push(payload)
			}else{
				state.concierge_order.custom[record_product].form = payload.form
			}
		},
		setSpecificConcierOrderCustom(state,payload){
			let cart_product = state.concierge_order.custom[payload.index]
			if(cart_product.product.promotion_affected.best == null || (cart_product.product.promotion_affected.best != null && cart_product.product.promotion_affected.best.promotion_type != "PROMO_CODE")){
				cart_product.old_data = JSON.parse(JSON.stringify(cart_product.product))
			}
			cart_product.product = payload.data
		},
		setConciergeOrderCustomLaundry(state,payload){
			if(state.concierge_order.custom.length > 0){
				if(state.concierge_order.custom[0].type != payload.type){
					console.log("DIFFERENT TYPE")
				}else{
					let record_service = state.concierge_order.custom.findIndex(data=> data.service.id == payload.service.id)
					if(record_service != -1){

						if(payload.type == 'kilo' && payload.action == 'update_notes'){
							state.concierge_order.custom[record_service].notes = payload.notes
						}else if(state.concierge_order.custom[record_service].type == 'kilo'){
							state.concierge_order.custom.splice(record_service,1)
						}else{

							let record_product = state.concierge_order.custom[record_service].product.findIndex(data=> data.data.id == payload.product.id)
							if(record_product != -1){

								if(payload.qty == 0){
									state.concierge_order.custom[record_service].product.splice(record_product,1)
									if(state.concierge_order.custom[record_service].product.length == 0){
										state.concierge_order.custom.splice(record_service,1)
									}
								}else{
									state.concierge_order.custom[record_service].product[record_product].data = payload.product
									state.concierge_order.custom[record_service].product[record_product].qty = payload.qty
									state.concierge_order.custom[record_service].product[record_product].notes = payload.notes
								}
								
							}else{
								state.concierge_order.custom[record_service].product.push({
									data : payload.product,
									qty : payload.qty,
									notes : payload.notes
								})

							}

						}

					}else{
						let params = payload
						if(payload.type == 'pcs'){
							params = {
								type: payload.type,
								service: payload.service,
								product: [
									{
										data: payload.product,
										qty: payload.qty,
										notes: payload.notes 
									}
								]
							}
						}
						state.concierge_order.custom.push(params)
					}
				}
			}else{
				let params = payload
				if(payload.type == 'pcs'){
					params = {
						type: payload.type,
						service: payload.service,
						product: [
							{
								data: payload.product,
								qty: payload.qty,
								notes: payload.notes  
							}
						]
					}
				}
				state.concierge_order.custom.push(params)
			}
		},
		resetSpecificConciergeOrderCustom(state,payload){
			let cart_product = state.concierge_order.custom[payload.index]

			cart_product.product = JSON.parse(JSON.stringify(cart_product.old_data))
			delete cart_product.old_data
		},
		removeConciergeOrderCustom(state,payload){
			let record_product = state.concierge_order.custom.findIndex(data=> data.product.id == payload)
			if(record_product != -1){
				state.concierge_order.custom.splice(record_product,1)
			}
		},
		setConciergeOrderPromoCode(state,payload){
			state.concierge_order.promo_code = payload
		},
		setConciergeOrderCustomModule(state,payload){
			state.concierge_order.module = payload
		},
		setConciergeOrderExperienceDate(state,payload){
			state.concierge_order.experience.date = payload
		},
		setConciergeOrderExperience(state,payload){
			// payload = {
			// 	merchant: {},
			// 	product: {},
			// 	variant: {},
			// 	qty: 1
			// }
			if(state.concierge_order.experience.cart.length == 0){
				state.concierge_order.experience.merchant = payload.merchant
			}else if(state.concierge_order.experience.merchant.id != payload.merchant.id){
				console.log("CANNOT ADD PRODUCT BECAUSE DIFFERENT MERCHANT")
			}

			if(Object.keys(state.concierge_order.experience.merchant).length > 0 && state.concierge_order.experience.merchant.id == payload.merchant.id){
				// find product in list
				let record_product = state.concierge_order.experience.cart.findIndex(product=> product.product.data.id == payload.product.id)

				// if product not found
				if(record_product == -1){
					let is_variant = payload.product.variant_list.length > 0 ? true : false 
					let copied_data = JSON.parse(JSON.stringify(payload))
					delete copied_data.product.variant_list

					if(is_variant){
						delete copied_data.variant.tax_services
					}

					let data = {
						product: {
							data: copied_data.product,
							is_variant: is_variant
						},
						variant: !is_variant ? [] : [{
							data: copied_data.variant,
							qty: payload.qty,
							notes: ''
						}],
						notes: '',
						qty: payload.qty
					}

					state.concierge_order.experience.cart.push(data)
				}else{
					if(state.concierge_order.experience.cart[record_product].product.is_variant){
						// find variant in product list car
						let record_variant = state.concierge_order.experience.cart[record_product].variant.findIndex(variant => variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id)

						// if variant is matches instead product list
						if(record_variant != -1){

							state.concierge_order.experience.cart[record_product].qty -= state.concierge_order.experience.cart[record_product].variant[record_variant].qty

							state.concierge_order.experience.cart[record_product].variant[record_variant].qty = payload.qty

							state.concierge_order.experience.cart[record_product].qty += state.concierge_order.experience.cart[record_product].variant[record_variant].qty
						}else{
							let copied_data_variant = JSON.parse(JSON.stringify(payload.variant))
							delete copied_data_variant.tax_services
							state.concierge_order.experience.cart[record_product].variant.push({
								data: copied_data_variant,
								notes: '',
								qty: payload.qty
							})
							state.concierge_order.experience.cart[record_product].qty += payload.qty
						}
					}else{
						state.concierge_order.experience.cart[record_product].qty = payload.qty
					}	
				}

			}
		},
		removeConciergeOrderExperience(state,payload){
			let record_product = state.concierge_order.experience.cart.findIndex(product=> product.product.data.id == payload.product.id)
			if(record_product != -1){
				let is_variant = state.concierge_order.experience.cart[record_product].product.is_variant
				if(is_variant){
					let record_variant = state.concierge_order.experience.cart[record_product].variant.findIndex(variant => variant.data.product_ga_pos_id == payload.variant.product_ga_pos_id)
					if(record_variant != -1){
						let temp_variant = state.concierge_order.experience.cart[record_product].variant[record_variant].qty
						state.concierge_order.experience.cart[record_product].variant.splice(record_variant,1)
						if(state.concierge_order.experience.cart[record_product].variant.length == 0){
							state.concierge_order.experience.cart.splice(record_product,1)
							if(state.concierge_order.experience.cart.length == 0){
								state.concierge_order.experience.merchant = {}
							}
						}else{
							state.concierge_order.experience.cart[record_product].qty -= temp_variant
						}
					}
				}else{
					state.concierge_order.experience.cart.splice(record_product,1)
					if(state.concierge_order.experience.cart.length == 0){
						state.concierge_order.experience.merchant = {}
					}
				}
			}
		},
		setConciergeOrderExperienceNote(state,payload){
			let record_p = state.concierge_order.experience.cart.findIndex(product=> product.product.data.id == payload.product_id)
			if(record_p == -1){
				console.log("ERROR WHILE ADDING NOTE : PRODUCT NOT FOUND")
			}else{
				if(payload.variant_id == ''){
					state.concierge_order.experience.cart[record_p].notes = payload.notes
				}else{
					let record_v = state.concierge_order.experience.cart[record_p].variant.findIndex(variant=> variant.data.id == payload.variant_id)
					if(record_v == -1){
						console.log("ERROR WHILE ADDING NOTE : VARIANT NOT FOUND")
					}else{
						state.concierge_order.experience.cart[record_p].variant[record_v].notes = payload.notes
					}
				}
			}

		},
		resetConciergeOrderExperience(state,payload){
			let record = state.concierge_order.experience.cart.findIndex(product=> product.product.data.id == payload)
			if(record != -1){
				state.concierge_order.experience.cart.splice(record,1)
				if(state.concierge_order.experience.cart.length == 0){
					state.concierge_order.experience.merchant = {}
				}
			}else{
				console.log("ERROR WHILE REMOVING PRODUCT : PRODUCT NOT FOUND")
			}
		},
		resetConciergeOrder(state,payload='default'){
			state.concierge_order.cart = []
			state.concierge_order.custom = []
			state.concierge_order.promo_code = ''
			state.concierge_order.module = ''
			state.concierge_order.experience = {
				merchant: {},
    		cart: [],
    		date: new Date()
			}
			if(payload == 'with_reward'){
				state.membership.reward = {}
			}
			if(payload == 'default'){
				state.concierge_order.date = new Date
			}
		},
		setConciergeReservationPerKey(state,payload){
			for (let param of payload){
				state.concierge_reservation[param.key] = param.value
				if(param.key == 'room'){
					state.room_stay = param.value
				}
			}
		},
		setConciergeReservation(state,payload){
			if(state.concierge_reservation.status == ''){
				state.concierge_reservation.status = payload.status
			}
			if(payload.guest_profile != null){
				state.concierge_reservation.guest_profile = payload.guest_profile
			}
			if(payload.room != null){
				state.concierge_reservation.room = payload.room
				state.room_stay = payload.room
			}
			if(payload.id != ''){
				state.concierge_reservation.reservation_id = payload.id
			}
		},
		setRoomStay(state, payload){
			state.room_stay = payload
		},
		resetAllDataHotel(state){
			state.be_filter= {
				date: {
					check_in: moment().toDate(),
					check_out: moment().add(1,'d').toDate(),
				},
				guest: {
					adult: 1,
					child: 0,
					infant: 0,
				},
				promo_code: '',
			}
			state.be_filter_detail={
				type: 'room_type',
				data: {}
			}
			state.agent_id= ''
			state.be_first_load = true,
			state.be_price= [0,0]
			state.be_sort_by= 'room_type'
			state.trx_be={
				room_rate_details: [],
				room_rate_guest: [],
				room_rate_custom: [],
				customer_details: {
					first_name: "",
					last_name: "",
					phone_number: "",
					email: "",
					address: "",
					title: "",
					country: "",
					nationality: "",
					day_of_birth: ""
				},
				visitor_details: {
					first_name: "",
					last_name: "",
					phone_number: "",
					email: "",
					address: "",
					title: "",
					country: "",
					nationality: "",
					day_of_birth: ""
				},
				ticket_owner: 'me',
				additional_service: [],
				special_request: [],
				qty: {
					room_rate: 0,
					additional_service: 0
				},
				custom_time:{
					check_in: '',
					check_out: ''
				},
				note: ''
			}
			state.be_trx_payment={}
			state.room_avbl=[]
			state.be_payment={
			}
			state.concierge={
				booking_number: '',
				pin: '',
				token: '',
				folio: '',
				detail_id: '',
				pin_applied: false
			}
			state.concierge_reservation={
				status: '',
				guest_profile: {},
				room: {},
				reservation_id: ''
			}
			state.concierge_order= {
				cart: [],
				custom: [],
				promo_code: '',
				date: new Date(),
				experience: {
					merchant: {},
					cart: [],
					date: new Date()
				},
				module: ''
			}
			state.room_stay= {}
			state.membership = {
				reward: {},
				referral: {}
			}
			state.reservation_active = {
				booking_number: '',
				detail_id: '',
				token: '',
				folio: '',
				user_id: ''
			}
      state.promotion = {},
      state.be_promotion_filter = { id: '', names: {}, is_membership: false, expired_at: '' },
      state.activeHotelModule = null,
      state.showAdditionalModuleInSearch = false,
      state.additionalServicePromotion = {}
		},
		setMembershipRewardApplied(state,payload){
			state.membership.reward = payload
			if(payload.id){
				state.be_filter.promo_code = ''
			}
		},
		setMembershipReferral(state,payload){
			state.membership.referral = payload
		},
		setReservationActive(state,payload){
			if(payload == 'reset'){
				state.reservation_active = {
					booking_number: '',
					detail_id: '',
					token: '',
					folio: '',
					user_id: ''
				}
			}else{
				for (let param of payload){
					state.reservation_active[param.key] = param.value
				}
			}
		},
		setSelectedPromotion(state,payload){
			const createdAt = moment().utc().format();
			const expiresAt = moment(createdAt).add(24, 'hours').utc().format();
			let selectedPromotion = Object.assign(payload, { vuex_expired_at : expiresAt});
			state.promotion = selectedPromotion;
			// whichever promotion the guest applied last wins over the promo_id link
			state.be_promotion_filter = { id: '', names: {}, is_membership: false, expired_at: '' };
		},
		resetSelectedPromotion(state){
      if(state.promotion && state.be_filter.promo_code === state.promotion.promo_code) state.be_filter.promo_code = ""
			state.promotion = {};
		},
		setBePromotionFilter(state, { id, names, isMembership }){
			const expiresAt = moment().utc().add(24, 'hours').format();
			state.be_promotion_filter = { id, names: names || {}, is_membership: isMembership === true, expired_at: expiresAt };
			state.promotion = {};
		},
		resetBePromotionFilter(state){
			state.be_promotion_filter = { id: '', names: {}, is_membership: false, expired_at: '' };
		},
    setActiveHotelModule(state, payload){
      state.activeHotelModule =  payload
    },
    setShowAdditionalModuleInSearch(state, payload){
      state.showAdditionalModuleInSearch = payload
    },
    setAdditionalServicePromotion(state, payload){
      state.additionalServicePromotion = payload
    }
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/hotel.js